import { components, useApi } from "@appretio/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateCubeMutation } from "../cubeMutationInvalidation";

type CopyCubeYearInput = components["schemas"]["CopyCubeYearInput"];

export function useCopyCubeYear() {
  const apiClient = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: CopyCubeYearInput) => {
      const response = await apiClient.POST("/v2/forecast/cubes/copy-year", {
        body: input
      });
      if (!response.data?.result) {
        throw new Error("Missing result in copy cube year response");
      }
      return response.data.result;
    },
    onSuccess: async () => {
      await invalidateCubeMutation(queryClient, { lifecycle: true });
    },
    meta: {
      errorMessage: "Failed to copy cube year"
    }
  });
}
